import { render, staticRenderFns } from "./KnEducationalLevel.vue?vue&type=template&id=7349ed52"
import script from "./KnEducationalLevel.js?vue&type=script&lang=js&external"
export * from "./KnEducationalLevel.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports